import { render, staticRenderFns } from "./labelManagement.vue?vue&type=template&id=6ad3bcb6&scoped=true&"
import script from "./labelManagement.vue?vue&type=script&lang=js&"
export * from "./labelManagement.vue?vue&type=script&lang=js&"
import style0 from "./labelManagement.vue?vue&type=style&index=0&id=6ad3bcb6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad3bcb6",
  null
  
)

export default component.exports